import React, { Fragment } from 'react'
import { Form, Input, Typography } from 'antd'
import PropTypes from 'prop-types'

const inlineLayout = {
  labelCol: { xs: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, lg: { span: 12 } },
}

const levelUpEmail = (
  <Typography.Text style={{ fontSize: '18px' }}>
    E-mail de cadastro Level Up:
  </Typography.Text>
)

const levelUpId = (
  <Typography.Text style={{ fontSize: '18px' }}>ID no jogo:</Typography.Text>
)

const levelUpServer = (
  <Typography.Text style={{ fontSize: '18px' }}>
    Servidor (caso tenha):
  </Typography.Text>
)

export const LevelUp = ({ handleChange, answers }) => {
  return (
    <Fragment>
      <Typography.Title level={4}>
        <span style={{ color: '#d60202' }}>*</span>4. Nos informe os seguintes
        dados da sua conta Level Up
      </Typography.Title>
      <Form.Item name='levelUpEmail' label={levelUpEmail} {...inlineLayout}>
        <Input
          type='text'
          name='levelUpEmail'
          value={answers?.levelUpEmail}
          onChange={handleChange('levelUpEmail')}
          required
        />
      </Form.Item>
      <Form.Item name='levelUpId' label={levelUpId} {...inlineLayout}>
        <Input
          type='text'
          name='levelUpId'
          value={answers?.levelUpId}
          onChange={handleChange('levelUpId')}
          required
        />
      </Form.Item>
      <Form.Item name='levelUpServer' label={levelUpServer} {...inlineLayout}>
        <Input
          type='text'
          name='levelUpServer'
          value={answers?.levelUpServer}
          onChange={handleChange('levelUpServer')}
        />
      </Form.Item>
    </Fragment>
  )
}

LevelUp.propTypes = {
  handleChange: PropTypes.func,
  answers: PropTypes.any,
}
